import { STATES } from '../constants/states';

const normaliseComparableText = (value) =>
  String(value ?? '')
    .replace(/[.\s]/g, '')
    .toLowerCase();

export const normaliseStateValue = (state) => {
  const comparableState = normaliseComparableText(state);

  if (!comparableState) return '';

  const matchedState = STATES.find(
    ({ value, label }) =>
      normaliseComparableText(value) === comparableState ||
      normaliseComparableText(label) === comparableState
  );

  return matchedState ? matchedState.value : '';
};
